import { httpClient } from 'api';
import { KnowledgeBaseArticle } from 'types/KnowledgeBase';
import { LabelPayload } from '../types/payloads/LabelPayload';

export const labelGenerationApi = {
	getBadgePreview: (applicationId: number, payload: LabelPayload) =>
		httpClient.post<any>(`label-generator/`, payload, {
			responseType: 'blob',
		}),
	updateBadgeData: (applicationId: number, payload: LabelPayload) =>
		httpClient.post<any>(`label-generator/data/${applicationId}`, payload, {
			responseType: 'blob',
		}),
	checkLabel: (applicationId: number) =>
		httpClient.get<KnowledgeBaseArticle | null>(`label-generator/check/${applicationId}`),
	getBadgeData: (applicationId: number) => httpClient.get<any>(`label-generator/data/${applicationId}`),
};
